import React, { useContext } from 'react';
import { FILTER, isRolesListings } from '@fiverr-private/listing_lib';
import { filterType } from '../../../../../../../types';
import { AppContext } from '../../../../../../context/listingsContext';
import Toggle, { TogglePropTypes } from '../toggle';

const ProToggle = ({ filter, usePillButton, ...rest }) => {
    const { flowName } = useContext(AppContext);
    if (!filter) {
        return null;
    }
    const keySuffix = isRolesListings(flowName) ? 'proRoleFlow' : 'pro';
    const titleKey =
        usePillButton && keySuffix === 'pro'
            ? 'search_perseus.filters.global.pro.filter_row_alias'
            : `search_perseus.filters.global.${keySuffix}.alias`;

    return (
        <Toggle
            selectedValue={FILTER.PRO.SELECTED_VALUE}
            title={titleKey}
            text={`search_perseus.filters.global.${keySuffix}.text`}
            {...filter}
            {...rest}
            usePillButton={usePillButton}
        />
    );
};

ProToggle.propTypes = {
    filter: filterType,
    ...TogglePropTypes,
};

export default ProToggle;
